/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Save_Save_AsInputs */

const en_save_save_as = /** @type {(inputs: Save_Save_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save/Save As Project`)
};

const fr_save_save_as = /** @type {(inputs: Save_Save_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer/Enregistrer sous le projet`)
};

const de_save_save_as = /** @type {(inputs: Save_Save_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichern/Speichern unter Projekt`)
};

const it_save_save_as = /** @type {(inputs: Save_Save_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva/Salva come progetto`)
};

const ru_save_save_as = /** @type {(inputs: Save_Save_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить/Сохранить как проект`)
};

const es_save_save_as = /** @type {(inputs: Save_Save_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar/Guardar como proyecto`)
};

const zh_cn2_save_save_as = /** @type {(inputs: Save_Save_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存/另存为项目`)
};

const ja_save_save_as = /** @type {(inputs: Save_Save_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存/名前を付けてプロジェクトを保存`)
};

const hi_save_save_as = /** @type {(inputs: Save_Save_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट सहेजें/इस रूप में सहेजें`)
};

const pt_pt2_save_save_as = /** @type {(inputs: Save_Save_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar/Salvar como projeto`)
};

/**
* | output |
* | --- |
* | "Save/Save As Project" |
*
* @param {Save_Save_AsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const save_save_as = /** @type {((inputs?: Save_Save_AsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Save_Save_AsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_save_save_as(inputs)
	if (locale === "de") return de_save_save_as(inputs)
	if (locale === "it") return it_save_save_as(inputs)
	if (locale === "ru") return ru_save_save_as(inputs)
	if (locale === "es") return es_save_save_as(inputs)
	if (locale === "zh-CN") return zh_cn2_save_save_as(inputs)
	if (locale === "ja") return ja_save_save_as(inputs)
	if (locale === "hi") return hi_save_save_as(inputs)
	if (locale === "pt-PT") return pt_pt2_save_save_as(inputs)
	return en_save_save_as(inputs)
});